import { render, staticRenderFns } from "./Blaze.vue?vue&type=template&id=1ec486d2&"
import script from "./Blaze.vue?vue&type=script&lang=js&"
export * from "./Blaze.vue?vue&type=script&lang=js&"
import style0 from "./Blaze.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.9.3_5301d49b91a5273e67d0261daf815cc2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports